import addDaysToDate from './date/addDaysToDate.js';
import getMainAndTopLevelDomain from './getMainAndTopLevelDomain.js';
const DAYS = 365;
const YEARS = 2;
const THRESHOLD_IN_DAYS = DAYS * YEARS;
/**
 * Set a cookie with given name and value
 * @param {Object.<string, any>} param
 * @param param.key - the key of the cookie
 * @param param.value - the value of the cookie
 * @param param.expirationThreshold - defaults to THRESHOLD_IN_DAYS
 */
export const setCookie = ({ key, value, expirationThreshold = THRESHOLD_IN_DAYS }) => {
    const domain = getMainAndTopLevelDomain(window.location.hostname);
    const future = addDaysToDate(new Date(), expirationThreshold);
    document.cookie = `${key}=${value}; Domain=${domain}; Expires=${future.toUTCString()}; Path=/`;
};
/**
 * Map cookies to a key value array
 * @example getCookieList(document.cookie);
 * // returns ['basket', 'empty']
 * @param cookies - a string with cookies from document.cookie
 */
export const getCookieList = (cookies) => {
    return cookies
        .split(';')
        .map((cookie) => cookie.trim())
        .map((cookie) => cookie.split('='));
};
/**
 * Get the value of a cookie by key
 * @example getCookieValue(parsedCookies, 'basket');
 * // returns 'empty'
 * @param parsedCookies - transformed from a string of cookies to a key/value pair list
 * @param key - the key of the cookie we want to get the value of
 */
export const getCookieValue = (parsedCookies, key) => {
    const foundCookie = parsedCookies.find((tuple) => {
        const [cookieKey] = tuple;
        return cookieKey === key;
    });
    if (foundCookie) {
        const [, value] = foundCookie;
        return value;
    }
    return '';
};
